import React, { useEffect, useState, useContext } from "react";
import AuthService from "../../services/auth-service";
import PasswordField from "../../components/common/PasswordField/PasswordField";
import TextField from "../../components/common/TextField";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Navigate } from "react-router-dom";
import ResetPassword from "./ResetPassword";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputComponent from "../../components/common/PhoneInput";
import PasswordField2 from "../../components/common/PasswordField/PasswordField2";
import Button from "../../components/common/Button";
import { LOGIN_SUCCESS } from "../../redux/actions/types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IPInfoContext } from 'ip-info-react';

const LoginForm = ({
  step,
  setStep,
  msisdn,
  setMsisdn,
  userType,
  toggleReset,
  callback,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [password, setPassword] = useState("");
  const [ipInfoJson, setIpInfoJson] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [staffOrAgent, setStaffOrAgent] = useState(undefined);
  const [validationMessage, setValidationMessage] = useState(null);

  const ipInfo = useContext(IPInfoContext);



  const handleLogin = (e) => {
    e.preventDefault();
    if (validateData()) {
      setLoading(true);
      AuthService.login(msisdn, password, userType)
        .then(({ data }) => {
          if (data?.expected_action != null) {
            setStep(step + 1);

            return;
          }

          let user = userType === "staff" ? data?.staff : data?.agent;
          if (userType === "staff") {
            user.isAdmin = true;
            user.type = "staff";
          } else {
            user.type = "agent";
            user.isAgent = true;
          }

          dispatch({
            type: LOGIN_SUCCESS,
            payload: {
              user: user,
              sessionId: data?.session_id,
            },
          });

          userType === "staff"
            ? navigate("/")
            : navigate("/send-money");
        })
        .catch((error) => {
          if (error?.response?.data?.code === 417) {
            setLoginError(
              error?.response?.data?.message
                ? error?.response.data.message
                : "Invalid Phone Number or Password"
            );
            if (
              error?.response?.data?.data?.expected_action === "change-password"
            ) {
              addToast(
                "Your credentials need to be reset. Please change your password",
                {
                  appearance: "info",
                  autoDismiss: true,
                  autoDismissTimeout: 5000,
                }
              );
              // setRedirect(true)
              if (userType === "agent") {
                if (error?.response?.data?.data?.agent) {
                  setStaffOrAgent(error.response.data.data.agent);
                  callback(true);
                } else {
                  setRedirect(true);
                }
              } else {
                if (error?.response?.data?.data?.staff) {
                  callback(true);
                  setStaffOrAgent(error.response.data.data.staff);
                } else {
                  setRedirect(true);
                }
              }
            }
          } else if (error?.data?.code === 400) {
            setLoginError("Invalid Request");
          } else {
            setLoginError("Something went wrong. Try again");
          }
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };
  const handlePhoneInput = (value) => {
    setMsisdn(value);
    setValidationMessage(null);
  };

  useEffect(() => {
    setLoginError("");
  }, [toggleReset, msisdn, password]);

  const validateData = () => {
    if (password.length < 5) {
      setLoginError("Enter a Valid Password");
    }
    if (!isValidPhoneNumber(msisdn)) {
      setValidationMessage("Enter a Valid Phone Number");
    }

    if (isValidPhoneNumber(msisdn) && password.length >= 5) {
      return true;
    }
  };

  if (redirect) {
    return (
      <Navigate
        to={userType === "agent" ? "/password-reset" : "/staff/password-reset"}
        replace
      />
    );
  }

  return !staffOrAgent || !toggleReset ? (
    <form className="w-full px-4 lg:px-0 mx-auto flex flex-col gap-8">
      {loginError && !loginError.includes("Password") && (
        <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg">
          <svg className="w-5 h-5 text-red-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <span className="text-sm text-red-800">{loginError}</span>
        </div>
      )}

      <div className="w-full z-10">
        <p className="text-2xl text-left text-black font-semibold">
          {" "}
          {!staffOrAgent || !toggleReset
            ? userType === "agent"
              ? "Agent Login"
              : "Staff Login"
            : "Change  Your Password"}
        </p>
      </div>

      <PhoneInputComponent
        labelFor={"msisdn"}
        labelName={"Phone Number"}
        placeholder="Enter phone number"
        value={msisdn}
        defaultCountry={ipInfo?.country_code}
        withCountryCallingCode
        international={true}
        containerStyles={validationMessage ? "error" : ""}
        validationMessage={validationMessage}
        handlePhoneInputChange={handlePhoneInput}
      />

      <PasswordField2
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter your password"
        error={loginError && loginError.includes("Password") ? loginError : null}
      />

      <div className="flex items-center w-full justify-between pt-2">
        <div className="flex items-center gap-2">
          <input 
            type="checkbox" 
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
          />
          <label className="text-sm text-gray-700" htmlFor="">
            Keep me signed in
          </label>
        </div>

        <div className="text-sm">
          <Link
            className="text-blue-600 hover:text-blue-800 underline"
            to={
              userType === "agent" ? "/password-reset" : "/staff/password-reset"
            }
          >
            Forgot your password?
          </Link>
        </div>
      </div>

      <div className="w-full flex items-center gap-4 flex-col pt-4">
        <Button
          onClick={handleLogin}
          loading={loading}
          disabled={loading}
          className="w-full"
          size="lg"
        >
          {!loading && (
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
          )}
          LOGIN
        </Button>

        {userType === "agent" ? (
          <Link 
            className="text-sm text-gray-600 hover:text-gray-800 hover:underline transition-colors duration-200" 
            to={"staff"}
          >
            Staff? Log in here.
          </Link>
        ) : (
          <Link 
            className="text-sm text-gray-600 hover:text-gray-800 hover:underline transition-colors duration-200" 
            to={""}
          >
            Agent? Log in here.
          </Link>
        )}
      </div>

      <div className="absolute bottom-4 left-16 label-text">
        ©2023 Instaant Transfers
      </div>
    </form>
  ) : (
    <ResetPassword staffOrAgent={staffOrAgent} userType={userType} />
  );
};

export default LoginForm;
